var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.823,
    height: 28.823,
    viewBox: "0 0 28.823 28.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_nouveau",
    "data-name": "picto nouveau",
    transform: "translate(-323.797 -614.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vid\\xE9o",
    transform: "translate(321.755 612.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1127",
    "data-name": "Trac\\xE9 1127",
    d: "M10,20.852l8.9-6.676L10,7.5Z",
    transform: "translate(3.486 2.277)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 13.662,
    cy: 13.662,
    r: 13.662,
    transform: "translate(2.792 2.792)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconBlack);
export default __webpack_public_path__ + "static/media/video-icon-black.45312a43882616229b80a8ed71f3a49f.svg";
export { ForwardRef as ReactComponent };